// extracted by mini-css-extract-plugin
module.exports = {"figure":"ImageSliderItem_figure__Xe4VG"};